"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandManager = void 0;
var inversify_1 = require("inversify");
var CommandManager = exports.CommandManager = /** @class */ (function () {
    function CommandManager(container) {
        this.container = container;
    }
    CommandManager.prototype.add = function (commandDefinition) {
        var symbolOf = this.getSymbol(commandDefinition.name);
        this.container.bind(symbolOf).to(commandDefinition.command);
    };
    CommandManager.prototype.exec = function (name) {
        var symbolOf = this.getSymbol(name);
        var commands = this.container.getAll(symbolOf);
        commands.forEach(function (command) { return command.exec(); });
    };
    CommandManager.prototype.getSymbol = function (name) {
        return Symbol.for("command_".concat(name));
    };
    CommandManager = __decorate([
        (0, inversify_1.injectable)(),
        __metadata("design:paramtypes", [inversify_1.Container])
    ], CommandManager);
    return CommandManager;
}());
//# sourceMappingURL=CommandManager.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/core/dist/services/impl/CommandManager.js
// module id = 858
// module chunks = 0